import { render, staticRenderFns } from "./detailTitle.vue?vue&type=template&id=2f6d1126&scoped=true&"
import script from "./detailTitle.vue?vue&type=script&lang=js&"
export * from "./detailTitle.vue?vue&type=script&lang=js&"
import style0 from "./detailTitle.vue?vue&type=style&index=0&id=2f6d1126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6d1126",
  null
  
)

export default component.exports